import type { TKpiOverviewDataScope } from '../../utils/uaRoiUaMediaScopeFilters';

/** metrics_trend 格式化后的图表体 */
export type TChartBody = {
  xAxisData?: string[];
  seriesData?: Record<string, unknown>[];
};

export const DEFAULT_API = '/api/v1/dashboard/pc/overview_daily/metrics_trend';

/** 须列入 trackData，beforeRequest 才能收到（见 PageContainer Service getApiData） */
export const DEFAULT_TRACK_DATA = [
  'extraParams',
  'gameCode',
  'metrics',
  'minTrendRangeDays',
] as const;

export interface INormalizedMetricsTrend {
  xAxisData: string[];
  seriesData: Record<string, unknown>[];
}

/** useKpiEventMetricMergedData 入参 */
export type TKpiEventMetricMergedParams = {
  // serviceData/trendState 来自外部 Service 容器，结构由上游决定；
  // hook 内部仅按 ...spread / 可选字段方式使用，故用 Record<string, unknown> 收敛
  serviceData: Record<string, unknown> | undefined;
  trendState: Record<string, unknown> | undefined;
  rawEventList: unknown;
  eventListLoading: unknown;
  anomalyResult: unknown;
  anomalyResultError: unknown;
  anomalyResultLoading?: unknown;
  /** 为 false 时不合并 AnomalyService 数据（商业化/素材团队图表不展示异常检测图例） */
  mergeAnomalyIntoTrend?: boolean;
  /** 指定当前图表对应 anomalyResult 中的顶层 key，仅匹配该 key 的异动数据会被合并 */
  anomalyMetricKey?: string;
  /**
   * KPI 总览 Tab 口径：`ua_roi_ua_media` 时使用异动接口 `uaroi` 分层，否则使用 `all`
   *（见 AnomalyService {@link pickKpiOverviewAnomalyLayer}）
   */
  kpiOverviewDataScope?: TKpiOverviewDataScope;
};
